import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import cardBodyStyle from '../../assets/jss/cardBodyStyle';

function CardBody({ classes, className, children, plain, profile, ...props }) {
  const cardBodyClasses = classNames({
    [classes.cardBody]: true,
    [classes.cardBodyPlain]: plain,
    [classes.cardBodyProfile]: profile,
    [className]: className !== undefined,
  });

  return (
    <div className={cardBodyClasses} {...props}>
      {children}
    </div>
  );
}

CardBody.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
};

export default withStyles(cardBodyStyle)(CardBody);
